var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battery-controls-mobile__container",class:{ disabled: _vm.isDisabled }},[_c('img',{staticClass:"battery-controls-mobile__icon",attrs:{"src":_vm.batteryImage}}),_c('div',{staticClass:"battery-level-controls-mobile",style:({ height: _vm.batteryLevelHeight })})])
}
var staticRenderFns = []

export { render, staticRenderFns }